import { memo, useState } from "react";
import Form from "../Form.js";
import Spinner from "../Spinner.js";
import { Typography, Button, Box } from "@mui/material";
import { createTransport } from "../../api/index.js";
import { useSnackbar } from "../../utils/index.js";
import { getTransportsHistory } from "../../api/index.js";
import TransportsHistoryPdf from "../../screens/orders/TransportsHistoryPdf.js";
import { ArrowBack } from "@mui/icons-material";
import useSelectStyles from "../styles/Select.js";

const AnimalTransferForm = ({
    selectedOwner,
    selectedAnimal,
    owners,
    ownersDropdownValues,
    setIsAnimalSelected
}) => {
    const [isLoading, setIsLoading] = useState(false);
    const [step, setStep] = useState(1);
    const [currentStatus, setCurrentStatus] = useState();
    const [transportsData, setTransportsData] = useState([]);

    const classes = useSelectStyles();
    const { success, error } = useSnackbar();
    const transferFormContent = [
        {
            customType: "dropdown",
            id: "owner",
            items: ownersDropdownValues,
            placeholder: "Νέα μονάδα στην οποία θα μεταφερθεί το ζώο",
            required: true,
        },
        {
            customType: "date-picker",
            id: "transferDate",
            type: "desktop",
            label: "Ημ/νία Μεταφοράς",
            width: "595px",
            background: "third",
            required: true,
        },
        // {
        //     customType: "input",
        //     id: "flockCode",
        //     type: "text",
        //     placeholder: "4-ψήφιος Κωδικός Εκτροφής που θα λάβει το ζώο στη νέα Μονάδα",
        //     required: true,
        // },
        {
            customType: "button",
            id: "submit",
            type: "submit",
            text: "Υποβολή"
        },
    ];

    const handleTransferSubmit = async (values) => {
        setIsLoading(true);
        const receivingOwner = owners.find((owner) => `${owner.code} - ${owner.lastName} ${owner.firstName}` === values.owner)
        console.log(values, selectedOwner, selectedAnimal, owners, receivingOwner)

        const valuesToSend = {
            sendOwner: selectedOwner._id,
            animal: selectedAnimal._id,
            receiveOwner: receivingOwner._id,
            transferDate: values.transferDate,
            // newFlockCode: values.flockCode
        };
        const { success: scs, message } = await createTransport(valuesToSend);
        if (scs) {
            success(message);
        } else {
            error(message);
        }
        setIsAnimalSelected(false);
        console.log("Values to send", valuesToSend)
        setIsLoading(false);
    }

    const handleHistoryClick = async () => {
        setIsLoading(true);
        console.log(selectedAnimal, selectedOwner)
        const { success: scs, transports, message } = await getTransportsHistory(selectedOwner._id, selectedAnimal._id);
        if (scs) {
            setCurrentStatus(transports.currentStatus);
            setTransportsData(transports.transportData);
            setStep(2);
        } else {
            error(message);
        }
        setIsLoading(false);
    }
    return (
        <>
            <Spinner open={isLoading} />
            {step === 1 && (
                <Box className={classes.outerBox}>
                    <Box container flexDirection="column" className={classes.innerBox}>
                        <Typography variant="h5" sx={{ margin: "1rem" }}>
                            Μεταφορά Ζώου
                        </Typography>
                        <Form content={transferFormContent} onSubmit={handleTransferSubmit} />
                        <Typography sx={{ mt: "1rem" }}>
                            Αν θέλετε να δείτε το Ιστορικό μεταφορών για το συγκεκριμένο Ζώο πατήστε εδώ.
                        </Typography>
                        <Button
                            onClick={handleHistoryClick}
                            sx={{ textTransform: 'none', padding: 0, color: 'secondary.main' }}
                        >
                            Ιστορικό
                        </Button>
                    </Box>
                </Box>
            )}
            {step === 2 && (
                <>
                    <Button
                        variant="outlined"
                        startIcon={<ArrowBack />}
                        onClick={() => setStep(1)}
                        sx={{ marginBottom: "1rem" }}
                    >
                    </Button>
                    <TransportsHistoryPdf currentStatus={currentStatus} transports={transportsData} />
                </>
            )}
        </>
    )
}

export default memo(AnimalTransferForm);